export default __webpack_public_path__ + "static/media/icomoon.90a77499.woff";